<template>
  <v-card
    class="px-3"
    flat
    tile
  >
    <v-card
      class=""
      flat
      tile
    >
      <v-row dense>
        <v-col>
          <span class="text-body-1 font-weight-bold grey--text text--darken-3">
            {{ $t("m.otherDetail") }}
          </span>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-text-field
            dense
            outlined
            hide-details="true"
            v-model="$store.state.vessel.otherForm.IMOCode"
            :label="$t('m.iMOCode')"
          />
        </v-col>
        <v-col>
          <v-text-field
            dense
            outlined
            hide-details="true"
            v-model="$store.state.vessel.otherForm.CallSign"
            :label="$t('m.callSign')"
          />
        </v-col>
        <v-col>
          <v-text-field
            dense
            outlined
            hide-details="true"
            v-model="$store.state.vessel.otherForm.PAndI"
            :label="$t('m.pAndI')"
          />
        </v-col>
        <v-col>
          <v-text-field
            dense
            outlined
            hide-details="true"
            v-model="$store.state.vessel.otherForm.ShipClass"
            :label="$t('m.class')"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-menu
            ref="ssDatemenu"
            v-model="ssDatemenu"
            :close-on-content-click="false"
            :return-value.sync="$store.state.vessel.otherForm.SSDate"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                outlined
                hide-details="true"
                v-model="$store.state.vessel.otherForm.SSDate"
                :label="$t('m.ss')"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="$store.state.vessel.otherForm.SSDate"
              :first-day-of-week="0"
              :locale="$i18n.locale"
              no-title
              scrollable
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="ssDatemenu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.ssDatemenu.save($store.state.vessel.otherForm.SSDate)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-menu
            ref="ddDatemenu"
            v-model="ddDatemenu"
            :close-on-content-click="false"
            :return-value.sync="$store.state.vessel.otherForm.DDDate"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                outlined
                hide-details="true"
                v-model="$store.state.vessel.otherForm.DDDate"
                :label="$t('m.dd')"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="$store.state.vessel.otherForm.DDDate"
              :first-day-of-week="0"
              :locale="$i18n.locale"
              no-title
              scrollable
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="ddDatemenu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.ddDatemenu.save($store.state.vessel.otherForm.DDDate)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            v-model="$store.state.vessel.otherForm.GrainCapacity"
            :label="$t('m.grainCapacity')"
            :suffix="$t('m.cbm')"
          />
        </v-col>
        <v-col>
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            v-model="$store.state.vessel.otherForm.BaleCapacity"
            :label="$t('m.baleCapacity')"
            :suffix="$t('m.cbm')"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="4">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            v-model="$store.state.vessel.otherForm.HoldNum"
            :label="$t('m.holdNum')"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            v-model="$store.state.vessel.otherForm.HatchNum"
            :label="$t('m.hatchNum')"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            dense
            outlined
            hide-details="true"
            type="number"
            v-model="$store.state.vessel.otherForm.DeckNum"
            :label="$t('m.deckNum')"
          />
        </v-col>
      </v-row>
    </v-card> <!-- 列表 row -->

    <v-card
      class="mt-2"
      flat
      tile
    >
      <v-tabs
        v-model="tab"
        show-arrows
      >
        <v-tab>{{ $t("m.mainEngine") }}</v-tab>
        <v-tab>{{ $t("m.shipyard") }}</v-tab>
        <v-tab>{{ $t("m.hatchType") }}</v-tab>
        <v-tab>{{ $t("m.hatchSize") }}</v-tab>
        <v-tab>{{ $t("m.holdSize") }}</v-tab>
        <v-tab>{{ $t("m.gearDesc") }}</v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="tab"
        :hide-slider="hideSlider"
      >
        <v-tab-item style="">
          <v-card
            class="mt-2"
            flat
          >
            <v-textarea
              outlined
              rows="4"
              placeholder="Main Engine"
              v-model="$store.state.vessel.otherForm.MainEngine"
            />
          </v-card>
        </v-tab-item style="">
        <v-tab-item>
          <v-card
            class="mt-2"
            flat
          >
            <v-textarea
              outlined
              rows="4"
              placeholder="Ship Yard"
              v-model="$store.state.vessel.otherForm.Shipyard"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card
            class="mt-2"
            flat
          >
            <v-textarea
              outlined
              rows="4"
              placeholder="Hatch Type"
              v-model="$store.state.vessel.otherForm.HatchType"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card
            class="mt-2"
            flat
          >
            <v-textarea
              outlined
              rows="4"
              placeholder="Hatch Size"
              v-model="$store.state.vessel.otherForm.HatchSize"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card
            class="mt-2"
            flat
          >
            <v-textarea
              outlined
              rows="4"
              placeholder="Hold Size"
              v-model="$store.state.vessel.otherForm.HoldSize"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card
            class="mt-2"
            flat
          >
            <v-textarea
              outlined
              rows="4"
              placeholder="Gear"
              v-model="$store.state.vessel.otherForm.GearDesc"
            />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'

export default {
  name: 'SupplementPad',
  components: { },
  props: [

  ],
  data () {
    return {
      tab: null,
      hideSlider: true,
      ssDatemenu: false,
      ddDatemenu: false
    }
  },
  created () {

  },
  computed: {
    ...mapState({
    }),

    ...mapGetters({
    })
  },
  watch: {

  },
  methods: {
    resetForm () {
    },

    clearForm () {
    }
  }

}
</script>

<style scoped>

</style>
